import React, { useEffect, useState } from "react";
import { NavLink, Image, ScrollArea } from "@mantine/core";
import {
  IconHome,
  IconFlag,
  IconCash,
  IconBackpack,
  IconGiftCard,
  IconBell,
  IconUsers,
  IconDeviceDesktop,
  IconUser,
  IconTarget,
  IconUserDollar,
  IconStar,
  IconDevicesPc,
  IconSquareAsterisk,
  IconUserPin,
  IconCake,
  IconCpu,
  IconCpuOff,
  IconBasket,
  IconBasketOff,
  IconBasketSearch,
  IconDeviceGamepad2,
  IconDevices2,
  IconMessage,
  IconTruck,
  IconMail,
  IconAdjustments,
  IconBrandWhatsapp,
  IconFileTypePdf,
  IconCategory
} from "@tabler/icons-react";
import { Link, useLocation } from "react-router-dom";
import classes from "./Navbar.module.css";
import viewnet from "../../images/viewnet.png";
import useAxiosPrivate from "../../auth/useAxiosPrivate";

import useAuth from "../../auth/useAuth";

interface CategoryItem {
  link: string;
  label: string;
  icon: React.ComponentType<any>;
  pendingCount?: number;
}

const category1: CategoryItem[] = [
  { link: "/feed", label: "Home Feed", icon: IconHome },
  { link: "/feed-category", label: "Feed Category", icon: IconCategory },
  { link: "/banner", label: "Banner", icon: IconFlag },
  { link: "/banner-web", label: "Banner Web", icon: IconFlag },
  { link: "/splash-screen", label: "Splash Screen", icon: IconStar },
  // { link: "/custom", label: "Custom PC (APP)", icon: IconDevicesPc },
  { link: "/transaction-history/coins", label: "Transaction History", icon: IconCash },
  { link: "/review", label: "Review", icon: IconMessage },
  { link: "/contact", label: "Contact Us (WhatsApp)", icon: IconBrandWhatsapp },
  { link: "/pdf-gpu", label: "PDF for Graphic Card", icon: IconFileTypePdf },
];

const category2: CategoryItem[] = [
  { link: "/member", label: "Member", icon: IconUsers },
];

const category4: CategoryItem[] = [
  { link: "/voucher", label: "Voucher", icon: IconGiftCard },
  { link: "/voucher-birthday", label: "Birthday Voucher", icon: IconCake },
  { link: "/notification", label: "Notification", icon: IconBell },
];

const category5: CategoryItem[] = [
  { link: "/admin", label: "Admin", icon: IconDeviceDesktop },
];

const category6: CategoryItem[] = [
  { link: "/staff", label: "Staff", icon: IconUser },
  { link: "/kpi", label: "KPI Objective", icon: IconTarget },
];

const category8: CategoryItem[] = [
    { link: "/terms", label: "Terms", icon: IconSquareAsterisk },
    { link: "/contact-us-message", label: "Contact Us", icon: IconMail },

]

const category10: CategoryItem[] = [
    { link: "/build-config-prebuild", label: "Prebuild PC", icon: IconDevices2 },
    { link: "/build-config-easy", label: "Easy Build Config", icon: IconDevicesPc },
    { link: "/build-config-custom", label: "Custom PC Config", icon: IconDevicesPc },
    { link: "/pc-component", label: "PC Components", icon: IconCpu },
    { link: "/pc-component-incomplete", label: "PC Components (Incomplete)", icon: IconCpuOff },
    { link: "/pc-component-parameter", label: "PC Components Parameters", icon: IconAdjustments },
    { link: "/store-item", label: "Store Items", icon: IconBasket },
    { link: "/store-item-incomplete", label: "Store Items (Incomplete)", icon: IconBasketOff },
    { link: "/all-item", label: "All Items", icon: IconBasketSearch },
]

const category9: CategoryItem[] = [
    { link: "/feed", label: "Home Feed", icon: IconHome },
  ];

//   const category11: CategoryItem[] = [
//     { link: "/pdf-price-list", label: "PDF Price List", icon: IconList },
//   ];

  const category12: CategoryItem[] = [
    { link: "/games-fps", label: "Games FPS", icon: IconDeviceGamepad2 },
  ];

function Navbar() {
  const {auth} = useAuth()
  const { pathname } = useLocation()
  const axiosPrivate = useAxiosPrivate();
  const [pendingDealerCount, setPendingDealerCount] = useState(0);
  const [pendingCorporateCount, setPendingCorporateCount] = useState(0);
  const [pendingWebOrderCount, setPendingWebOrderCount] = useState(0);

  const category3: CategoryItem[] = [
    { link: "/web-order/pending", label: "Web Order", icon: IconTruck , pendingCount: pendingWebOrderCount },
    { link: "/merchandise", label: "Merchandise", icon: IconBackpack },
  ];

  const category7: CategoryItem[] = [
      { link: "/dealer", label: "Dealer", icon: IconUserDollar, pendingCount: pendingDealerCount },
      { link: "/corporate", label: "Corporate", icon: IconUserPin, pendingCount: pendingCorporateCount },
    ];
    
  // Trigger counting of pending verification of dealer and corporate accounts when pathname changes
  useEffect(() => {
    const fetchPendingDealerCounts = async() => {
      try{
        const dealerRes = await axiosPrivate.post("/api/admin/dealer/read-pending")
        setPendingDealerCount(dealerRes.data.totalRows)
      } catch (error){
        console.error("Failed to fetch pending dealer count:", error);
      }
    }
    const fetchPendingCorporateCounts = async() => {
      try{
        const corporateRes = await axiosPrivate.post("/api/admin/corporate/read-pending")
        setPendingCorporateCount(corporateRes.data.totalRows)
      } catch (error){
        console.error("Failed to fetch pending corporate count:", error);
      }
    }
    const fetchPendingWebOrderCounts = async() => {
      try{
        const webOrderRes = await axiosPrivate.post("/api/admin/sales-order/read-pending")
        setPendingWebOrderCount(webOrderRes.data.totalRows)
      } catch (error){
        console.error("Failed to fetch pending corporate count:", error);
      }
    }
    fetchPendingDealerCounts();
    fetchPendingCorporateCounts();
    fetchPendingWebOrderCounts();
  }, [pathname])
  
  const renderLinks = (category: CategoryItem[]) =>
    category.map((item) => (
      <Link
        className={`${classes.link} ${
            item.link.split("/")[1] === pathname.split("/")[1] ? classes.activeLink : ""
        }`}
        to={item.link}
        key={item.label}
      >
        <item.icon className={classes.linkIcon} stroke={1.5} size={20}/>
        <span style={{ flex: 1 }}>{item.label}</span>

        {typeof item.pendingCount === 'number' && item.pendingCount > 0 && (
          <div className={classes.pendingBadge}>
            {item.pendingCount}
          </div>
        )}
      </Link>
    ));

  return (
    <nav id="nav-bar" className={classes.navbar}>
      <div className={classes.navbarMain}>
        <div className={classes.header}>
          <Image src={viewnet} alt="ViewNet logo" w={150} h={50} fit="contain" />
        </div>
        <div className={classes.navbarContainer}>
        <ScrollArea h={'100%'} w={'100%'}>
        {auth.role === 'admin' ?
        <>
            <NavLink
            label="General"
            defaultOpened
            styles={{children: {paddingLeft: 6}, root: {padding: "6px 10px"}}}
            active={
                category1.some(value => { return value.link.split("/")[1] === pathname.split("/")[1] })
            }
            style={{
                borderLeft: category1.some(value => { return value.link.split("/")[1] === pathname.split("/")[1] })
                    ? '6px solid #6A207F'
                    : "0px solid #6A207F",
                color: "#000000",
                backgroundColor: "#F3F0FF",
            }}
            >
            {renderLinks(category1)}
            </NavLink>

            <NavLink
            label="Profile"
            defaultOpened
            styles={{children: {paddingLeft: 6}, root: {padding: "6px 10px"}}}
            active={category2.some(value => { return value.link.split("/")[1] === pathname.split("/")[1] })}
            style={{
                borderLeft: category2.some(value => { return value.link.split("/")[1] === pathname.split("/")[1] }) ? '6px solid #6A207F' : "0px solid #6A207F",
                color: "#000000",
                backgroundColor: "transparent",
            }}
            >
            {renderLinks(category2)}
            </NavLink>

            <NavLink
            label="Verification"
            defaultOpened
            styles={{children: {paddingLeft: 6}, root: {padding: "6px 10px"}}}
            active={category7.some(value => { return value.link.split("/")[1] === pathname.split("/")[1] })}
            style={{
                borderLeft: category7.some(value => { return value.link.split("/")[1] === pathname.split("/")[1] }) ? '6px solid #6A207F' : "0px solid #6A207F",
                color: "#000000",
                backgroundColor: "#F3F0FF",
            }}
            >
            {renderLinks(category7)}
            </NavLink>

            <NavLink
            label="E-commerce"
            defaultOpened
            styles={{children: {paddingLeft: 6}, root: {padding: "6px 10px"}}}
            active={
                category3.some(value => { return value.link.split("/")[1] === pathname.split("/")[1] })
            }
            style={{
                borderLeft: 
                    category3.some(value => { return value.link.split("/")[1] === pathname.split("/")[1] })
                    ? '6px solid #6A207F' : "0px solid #6A207F",
                color: "#000000",
                backgroundColor: "transparent",
            }}
            >
            {renderLinks(category3)}
            </NavLink>

            <NavLink
            label="Marketing"
            defaultOpened
            styles={{children: {paddingLeft: 6}, root: {padding: "6px 10px"}}}
            active={
                category4.some(value => { return value.link.split("/")[1] === pathname.split("/")[1] })
            }
            style={{
                borderLeft: 
                    category4.some(value => { return value.link.split("/")[1] === pathname.split("/")[1] })
                ? '6px solid #6A207F' : "0px solid #6A207F",
                color: "#000000",
                backgroundColor: "#F3F0FF",
            }}
            >
            {renderLinks(category4)}
            </NavLink>

            <NavLink
            label="Account"
            defaultOpened
            styles={{children: {paddingLeft: 6}, root: {padding: "6px 10px"}}}
            active={category5.some(value => { return value.link.split("/")[1] === pathname.split("/")[1] })}
            style={{
                borderLeft: 
                    category5.some(value => { return value.link.split("/")[1] === pathname.split("/")[1] })
                    ? '6px solid #6A207F' : "0px solid #6A207F",
                color: "#000000",
                backgroundColor: "transparent",
            }}
            >
            {renderLinks(category5)}
            </NavLink>

            <NavLink
            label="Performance"
            defaultOpened
            styles={{children: {paddingLeft: 6}, root: {padding: "6px 10px"}}}
            active={
                category6.some(value => { return value.link.split("/")[1] === pathname.split("/")[1] })
            }
            style={{
                borderLeft: 
                    category6.some(value => { return value.link.split("/")[1] === pathname.split("/")[1] })
                ? '6px solid #6A207F' : "0px solid #6A207F",
                color: "#000000",
                backgroundColor: "#F3F0FF",
            }}
            >
            {renderLinks(category6)}
            </NavLink>

            <NavLink
            label="Miscellaneous"
            defaultOpened
            styles={{children: {paddingLeft: 6}, root: {padding: "6px 10px"}}}
            active={
                category8.some(value => { return value.link.split("/")[1] === pathname.split("/")[1] })
            }
            style={{
                borderLeft: 
                    category8.some(value => { return value.link.split("/")[1] === pathname.split("/")[1] })
                ? '6px solid #6A207F' : "0px solid #6A207F",
                color: "#000000",
                backgroundColor: "transparent",
            }}
            >
            {renderLinks(category8)}
            </NavLink>

            <NavLink
            label="Products"
            defaultOpened
            styles={{children: {paddingLeft: 6}, root: {padding: "6px 10px"}}}
            active={
                category10.some(value => { return value.link.split("/")[1] === pathname.split("/")[1] })
            }
            style={{
                borderLeft: 
                category10.some(value => { return value.link.split("/")[1] === pathname.split("/")[1] })
                ? '6px solid #6A207F' : "0px solid #6A207F",
                color: "#000000",
                backgroundColor: "#F3F0FF",
            }}
            >
            {renderLinks(category10)}
            </NavLink>

            <NavLink
            label="Games"
            defaultOpened
            styles={{children: {paddingLeft: 6}, root: {padding: "6px 10px"}}}
            active={
                category12.some(value => { return value.link.split("/")[1] === pathname.split("/")[1] })
            }
            style={{
                borderLeft: 
                category12.some(value => { return value.link.split("/")[1] === pathname.split("/")[1] })
                ? '6px solid #6A207F' : "0px solid #6A207F",
                color: "#000000",
                backgroundColor: "#F3F0FF",
            }}
            >
            {renderLinks(category12)}
            </NavLink>
        </>
            : auth.role === 'content' ?
        <>
            <NavLink
            label="General"
            defaultOpened
            styles={{children: {paddingLeft: 6}, root: {padding: "6px 10px"}}}
            active={
                category9.some(value => { return value.link.split("/")[1] === pathname.split("/")[1] })
            }
            style={{
                borderLeft: category9.some(value => { return value.link.split("/")[1] === pathname.split("/")[1] })
                    ? '6px solid #6A207F'
                    : "0px solid #6A207F",
                color: "#000000",
                backgroundColor: "#F3F0FF",
            }}
            >
            {renderLinks(category9)}
            </NavLink>
        </>
        :  auth.role === 'manager' ?
        <>
            <NavLink
            label="Verification"
            defaultOpened
            styles={{children: {paddingLeft: 6}, root: {padding: "6px 10px"}}}
            active={category7.some(value => { return value.link.split("/")[1] === pathname.split("/")[1] })}
            style={{
                borderLeft: category7.some(value => { return value.link.split("/")[1] === pathname.split("/")[1] }) ? '6px solid #6A207F' : "0px solid #6A207F",
                color: "#000000",
                backgroundColor: "#F3F0FF",
            }}
            >
            {renderLinks(category7)}
            </NavLink>
        </>
        : auth.role === 'price-list' ?
        <>
        </>
        :
        <>
        </>
        }

        </ScrollArea>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
